function Ctrl($scope, $state, $timeout, authService, utilsService, loggerService) {
  $scope.loginSubmitting = null;
  $scope.loginResult = null;
  $scope.loginBtnOptions = {
    buttonDefaultText: 'Log In',
    buttonSubmittingText: 'Logging in...',
    buttonSuccessText: 'Login succesful',
    buttonErrorText: 'Error logging in',
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonSuccessClass: 'btn-success',
    buttonErrorClass: 'btn-danger'
  };

  // sign up button
  $scope.signUpSubmitting = null;
  $scope.signUpResult = null;
  $scope.signUpBtnOptions = {
    buttonDefaultText: 'Sign Up',
    buttonSubmittingText: 'Processing...',
    buttonSuccessText: 'Sign up succesful',
    buttonErrorText: 'Error error signing up',
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonSuccessClass: 'btn-success',
    buttonErrorClass: 'btn-danger'
  };

  $scope.create = function(user) {
    if (!user) return;

    $scope.signUpSubmitting = true;

    const userObj = {
      email: user.email,
      password: user.password,
      firstName: user.firstName,
      lastName: user.lastName
    };

    authService.register(userObj, function(response) {
      $scope.signUpSubmitting = false;

      $timeout(function() {
        $scope.signUpResult = 'success';
        success(response);
      }, 100);

    }, function(response) {
      $scope.signUpSubmitting = false;
      $scope.signUpResult = 'error';
      $scope.errorMsg = utilsService.errorMessage(response);

      error(response, $scope.errorMsg);
    });
  };

  $scope.login = function(user) {
    $scope.loginSubmitting = true;
    $scope.errorMsg = null;

    authService.login(user.email, user.password, response => {
      $scope.loginSubmitting = false;

      $timeout(() => {
        $scope.loginResult = 'success';
        success(response);
      }, 100);
    }, response => {
      $scope.loginSubmitting = false;
      $scope.loginResult = 'error';
      $scope.errorMsg = utilsService.errorMessage(response);

      error(response, $scope.errorMsg);
    });
  };

  $scope.changeState = function(newState) {
    if (newState !== 'newUser' && newState !== 'existingUser') return;

    $scope.errorMsg = null;

    $scope.config.currentState = newState;
  };

  const success = function(response) {
    $scope.config.facebookLogin = false;

    if ($scope.callback) {
      $scope.callback(response);
    }
  };

  const error = function(response) {
    loggerService.error(response);

    if ($scope.callback) {
      $scope.callback(response, 'Error Logging In.');
    }
  };
}

Ctrl.$inject = [
  '$scope',
  '$state',
  '$timeout',
  'tl.auth.service',
  'utilsService',
  'loggerService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/loginEmail/controller.js